export const PractitionerScheduleEntryType: {
    AVAILABLE: 'AVAILABLE',
    BLOCKED: 'BLOCKED',
} = {
    AVAILABLE: 'AVAILABLE',
    BLOCKED: 'BLOCKED',
};

export type PractitionerScheduleEntryType = (typeof PractitionerScheduleEntryType)[keyof typeof PractitionerScheduleEntryType]